import { lazy } from 'react';
const Auth = lazy(() => import('./Auth'));
export default Auth;
